var exports = {
  "pz": "sidebar__2F9y3j",
  "H$": "taskContent__MqKbOf",
  "Oj": "taskTitle__EUjPuW",
  "Me": "readinessSection__rPnIOK",
};

module.exports = exports;
